import { CriteriaBuilder, ExpressionBuilder, Serialisers } from '@genesislcap/foundation-criteria';
export function dataserverCriteriaBuilder(datasource, value) {
    var _a;
    const criteriaBuilder = new CriteriaBuilder();
    criteriaBuilder.withExpression(new ExpressionBuilder()
        .withField((_a = datasource.labelField) !== null && _a !== void 0 ? _a : datasource.valueField)
        .withValue(value)
        .withSerialiser(Serialisers.containsIgnoreCase)
        .build());
    datasource.criteria = criteriaBuilder.build();
}
export function requestServerCriteriaBuilder(datasource, value) {
    var _a;
    const requestFieldName = (_a = datasource.labelField) !== null && _a !== void 0 ? _a : datasource.valueField;
    datasource.request = {
        [requestFieldName]: `${value}*`,
    };
    datasource.fetchGenesisData(false);
}
